import { ExportMode } from "@cayo/shared";
import { IntlShape } from "react-intl";
import { commandBarMessages } from "../../CommandBar/messages";

export const localizedExportMode = (mode: ExportMode, intl: IntlShape): string => {
  switch (mode) {
    case "visible":
      return intl.formatMessage(commandBarMessages.visible);
    case "selected":
      return intl.formatMessage(commandBarMessages.selected);
    default:
      return mode;
  }
};
